import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import { QuitRaidOutput, WebAppRoutes } from "types/web-app";

export const quitRaid = async (
  token: string,
  raidId: string,
): Promise<ServiceResponse<QuitRaidOutput>> => {
  const response = await fetchWithAuth(`/${WebAppRoutes.QUIT_RAID}`, token, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ raid_id: raidId }),
  });

  return response.json();
};
